import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MdArrowBack,
    MdPerson,
    MdPhone,
    MdCalendarToday,
    MdWarning,
    MdCheckCircle,
    MdAutoFixHigh,
    MdSave
} from 'react-icons/md';

import { authAPI } from 'services/api';

const CommonCreateNewCustomer = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        phone: '',
        birth_date: ''
    });

    // Telefon input kontrolü (Sadece rakam ve maks 10 hane)
    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) {
            setFormData({ ...formData, phone: value });
        }
    };

    // Rastgele Telefon Numarası Üretici (500 ile başlar)
    const generateRandomPhone = () => {
        // 500'den sonra 7 haneli rastgele sayı üret
        const randomPart = Math.floor(1000000 + Math.random() * 9000000).toString();
        setFormData({ ...formData, phone: `500${randomPart}` });
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.name || !formData.surname || !formData.phone) {
      setError("Lütfen zorunlu alanları doldurunuz (İsim, Soyisim, Telefon).");
      return;
    }

    if (formData.phone.length !== 10 || !formData.phone.startsWith("5")) {
      setError("Telefon numarası 5 ile başlamalı ve 10 haneli olmalıdır.");
      return;
    }

    setLoading(true);

    try {
      const formattedPhone = `+90${formData.phone}`;

      // MANTIK GÜNCELLEMESİ: Tarih boşsa '0001-01-01' ata
      const finalBirthDate = formData.birth_date
        ? formData.birth_date
        : "0001-01-01";

      const payload = {
        name: formData.name,
        surname: formData.surname,
        phone: formattedPhone,
        email: "mail@giriniz.com",
        password: "123456!",
        password_confirmation: "123456!",
        birth_date: finalBirthDate,
        role: "customer",
      };

      await authAPI.register(payload);

      // --- YENİ EKLENEN KISIM (Yönlendirme iptal edildi, form sıfırlanıyor) ---
      setSuccess(
        "Müşteri kaydı başarıyla eklendi! Yeni müşteri ekleyebilirsiniz."
      );

      // Formu tertemiz yap
      setFormData({
        name: "",
        surname: "",
        phone: "",
        birth_date: "",
      });

      // Başarı mesajını 3 saniye sonra ekrandan sil (Adam seri eklerken ekran kalabalık olmasın)
      setTimeout(() => {
        setSuccess("");
      }, 3000);
      // --- YENİ EKLENEN KISIM SONU ---
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message || "Kayıt sırasında bir hata oluştu."
      );
    } finally {
      setLoading(false);
    }
  };

    return (
        <div className="mt-5 flex w-full flex-col gap-6 pb-20 animate-fadeIn">

            {/* 1. ÜST BAR (GERİ DÖN VE BAŞLIK) */}
            <div className="flex items-center gap-4 bg-white p-6 rounded-[20px] shadow-3xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none border border-gray-100 dark:border-white/10">
                <button
                    onClick={() => navigate(-1)}
                    className="flex h-12 w-12 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100 dark:border-white/10 dark:bg-navy-900 dark:text-gray-300 dark:hover:bg-navy-700 transition-all active:scale-95"
                >
                    <MdArrowBack className="text-2xl" />
                </button>
                <div>
                    <h4 className="text-xl font-bold text-navy-700 dark:text-white">Yeni Müşteri Kaydı</h4>
                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                        Sisteme manuel olarak yeni bir müşteri profili ekleyin.
                    </p>
                </div>
            </div>

            {/* BİLDİRİMLER */}
            {error && (
                <div className="flex items-center gap-3 p-4 rounded-xl bg-red-50 text-red-600 border border-red-200 dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400 text-sm font-bold shadow-sm">
                    <MdWarning className="text-2xl flex-none" /> {error}
                </div>
            )}

            {success && (
                <div className="flex items-center gap-3 p-4 rounded-xl bg-green-50 text-green-600 border border-green-200 dark:bg-green-500/10 dark:border-green-500/20 dark:text-green-400 text-sm font-bold shadow-sm">
                    <MdCheckCircle className="text-2xl flex-none" /> {success}
                </div>
            )}

            {/* 2. FORM KARTI */}
            <div className="bg-white dark:bg-navy-800 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10 overflow-hidden">
                <div className="p-6 md:p-8">

                    {/* BİLGİ NOTU */}
                    <div className="flex items-start gap-3 p-4 mb-8 rounded-xl bg-brand-50 text-brand-500 border border-brand-100 dark:bg-brand-400/10 dark:border-brand-400/20 dark:text-brand-400">
                        <MdWarning className="text-xl flex-none mt-0.5" />
                        <p className="text-sm font-medium">
                            Sisteme kaydedilecek şifre varsayılan olarak <strong className="font-black">123456!</strong> olacaktır. Kullanıcı daha sonra profil ayarlarından bu şifreyi değiştirebilir.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                            {/* İSİM */}
                            <div>
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-2 ml-1 block">İsim *</label>
                                <div className="relative">
                                    <MdPerson className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
                                    <input
                                        type="text"
                                        placeholder="Müşteri Adı"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        className="w-full h-12 pl-12 pr-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all shadow-sm"
                                    />
                                </div>
                            </div>

                            {/* SOYİSİM */}
                            <div>
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-2 ml-1 block">Soyisim *</label>
                                <div className="relative">
                                    <MdPerson className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
                                    <input
                                        type="text"
                                        placeholder="Müşteri Soyadı"
                                        value={formData.surname}
                                        onChange={(e) => setFormData({ ...formData, surname: e.target.value })}
                                        className="w-full h-12 pl-12 pr-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all shadow-sm"
                                    />
                                </div>
                            </div>

                            {/* TELEFON (DARK MODE HATASI ÇÖZÜLDÜ) */}
                            <div className="md:col-span-2">
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-2 ml-1 block">Telefon Numarası *</label>
                                <div className="flex h-12 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-white/10 focus-within:border-brand-500 transition-all">
                                    <div className="flex items-center justify-center px-4 bg-gray-100 dark:bg-navy-800 border-r border-gray-200 dark:border-white/10">
                    <span className="text-sm font-black text-gray-600 dark:text-gray-300 flex items-center gap-1">
                      <MdPhone className="text-brand-500" /> +90
                    </span>
                                    </div>
                                    {/* bg-transparent yerine doğrudan dark:bg-navy-900 verildi */}
                                    <input
                                        type="tel"
                                        placeholder="5XX XXX XX XX"
                                        value={formData.phone}
                                        onChange={handlePhoneChange}
                                        maxLength={10}
                                        className="flex-1 w-full h-full px-4 text-sm font-bold text-navy-700 dark:text-white bg-gray-50 dark:bg-navy-900 outline-none"
                                    />
                                    <button
                                        type="button"
                                        onClick={generateRandomPhone}
                                        className="flex items-center justify-center px-4 bg-brand-50 hover:bg-brand-100 dark:bg-brand-400/10 dark:hover:bg-brand-400/20 text-brand-500 border-l border-gray-200 dark:border-white/10 transition-colors"
                                        title="Rastgele Numara Üret"
                                    >
                                        <MdAutoFixHigh className="text-xl" />
                                    </button>
                                </div>
                                <span className="text-[10px] font-bold text-gray-400 ml-1 mt-1 block">
                  * Başında 0 olmadan 10 haneli giriniz. Veya asistan butonuna tıklayıp rastgele doldurabilirsiniz.
                </span>
                            </div>

                            {/* DOĞUM TARİHİ */}
                            <div className="md:col-span-2">
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-2 ml-1 block">Doğum Tarihi (Opsiyonel)</label>
                                <div className="relative">
                                    <MdCalendarToday className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
                                    <input
                                        type="date"
                                        value={formData.birth_date}
                                        onChange={(e) => setFormData({ ...formData, birth_date: e.target.value })}
                                        className="w-full h-12 pl-12 pr-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all shadow-sm"
                                    />
                                </div>
                            </div>

                        </div>

                        {/* BUTON */}
                        <div className="flex justify-end pt-4 mt-2 border-t border-gray-100 dark:border-white/10">
                            <button
                                type="submit"
                                disabled={loading}
                                className="flex items-center justify-center gap-2 h-12 px-10 rounded-xl bg-brand-500 text-white text-sm font-bold shadow-lg shadow-brand-500/30 hover:bg-brand-600 disabled:opacity-50 transition-all active:scale-95 w-full md:w-auto"
                            >
                                {loading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <><MdSave className="text-xl" /> Kaydı Tamamla</>}
                            </button>
                        </div>

                    </form>
                </div>
            </div>

        </div>
    );
};

export default CommonCreateNewCustomer;